<template>
	<div class="index">
                <main>
                    <span>车牌： </span>
                    <el-input v-model="chepai_search" placeholder="请输入车牌"></el-input>
                    
                    <span>运载类别： </span>
                    <el-select v-model="type" placeholder="请选择">
                        <el-option label="污水" value="污水"></el-option>
                        <el-option label="污泥" value="污泥"></el-option>
                    </el-select>
                    
                    <span>猪场： </span>
                    <el-select v-model="address" placeholder="请选择猪场">
                        <el-option
                            v-for="(item,i) in options"
                            :key="i"
                            :label="item"
                            :value="item">
                        </el-option>
                    </el-select>

                    <span>状态： </span>
                    <el-select v-model="zhuangtai" placeholder="请选择">
                        <el-option label="待审核" value="0"></el-option>
                        <el-option label="通过" value="1"></el-option>
                        <el-option label="拒绝" value="2"></el-option>
                    </el-select>

                    <br/>
                    <br/>
 
                    <span>司机： </span>
                    <el-input v-model="siji" placeholder="请输入司机姓名"></el-input>

                    <span>起止日期： </span>
                    <el-date-picker
                        style="width:338px"
                        v-model="time"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        format="yyyy 年 MM 月 dd 日"
                        value-format="yyyy-MM-dd">
                    </el-date-picker>

                    <el-button style="margin-left:44px" type="success" icon="el-icon-search" @click="search()">搜索</el-button>
                    <el-button type="info" icon="el-icon-download" @click="daochu()">导出</el-button>

                </main>
                
                <el-card style="border: solid #ccc 1px">
                    <el-table
                        :data="tableData"
                        stripe
                        border
                        height="70vh">
                        <el-table-column
                            prop="create_time"
                            label="时间">
                        </el-table-column>

                        <el-table-column
                            prop="zhuchang"
                            label="猪场">
                        </el-table-column>

                        <el-table-column
                            prop="type"
                            label="运载类别">
                        </el-table-column>

                        <el-table-column
                            prop="danwei"
                            label="运载单位">
                        </el-table-column>

                        <el-table-column
                            prop="chepai"
                            label="车牌">
                        </el-table-column>

                        <el-table-column
                            prop="number"
                            label="定额装载">
                        </el-table-column>

                        <el-table-column
                            prop="tel"
                            label="电话">
                        </el-table-column>

                        <el-table-column
                            prop="name"
                            label="姓名">
                        </el-table-column>

                        <el-table-column
                            prop="info1"
                            label="装前">
                        </el-table-column>

                        <el-table-column
                            prop="info2"
                            label="装后">
                        </el-table-column>

                        <el-table-column
                            prop="now"
                            label="当期装载">
                        </el-table-column>

                        <el-table-column
                            prop="info3"
                            label="出发里程">
                        </el-table-column>

                        <el-table-column
                            prop="info4"
                            label="结束里程">
                        </el-table-column>

                        <el-table-column prop="beizhu" label="备注">
                            <template slot-scope="scope">
                                <p>{{scope.row.beizhu}}</p>
                            </template>
                        </el-table-column>

                        <el-table-column
                            prop="time"
                            label="业务时间">
                        </el-table-column>
                        
                        <el-table-column
                            width="520"
                            label="照片">
                            <template slot-scope="scope">
                                <span v-for="(item,i) in (scope.row.url).split(',')">
                                    <el-popover
                                        placement="bottom"
                                        trigger="click">
                                        <img :src="item" alt="" style="width:500px;height:500px">
                                        <img :src="item" alt="" style="width:100px;height:100px;margin-right:20px" slot="reference" >
                                    </el-popover>
                                </span>
                            </template>
                        </el-table-column>

                        <el-table-column label="状态">
                            <template slot-scope="scope">
                                <p v-if="scope.row.status==0">待审核</p>
                                <p style="color:#67C23A" v-if="scope.row.status==1">审核通过</p>
                                <p style="color:#F56C6C" v-if="scope.row.status==2">审核拒绝</p>
                            </template>
                        </el-table-column>

                        <el-table-column label="审核" width="160">
                            <template slot-scope="scope">
                                <!-- <div v-if="scope.row.status!=1"> -->
                                    <el-button type="text" @click="caoZuo1(scope.row.id,1)">通过</el-button>
                                    <el-button type="text" style="color:#F56C6C" @click="caoZuo1(scope.row.id,2)">拒绝</el-button>
                                    <el-button type="text" style="color:#E6A23C" @click="edit(scope.row)">修改</el-button>
                                    <el-button type="text" style="color:#909399" @click="caoZuo1(scope.row.id,3)">删除</el-button>
                                <!-- </div> -->
                            </template>
                        </el-table-column>

                        <el-table-column
                            prop="shenpi_time"
                            label="审核时间">
                        </el-table-column>

                        <el-table-column
                            prop="shenpiren"
                            label="审核人">
                        </el-table-column>
                    </el-table>

                    <el-pagination
                        style="margin:20px 0"
                        background
                        @current-change="handleCurrentChange"
                        :current-page="current_page"
                        :page-size="per_page"
                        layout="prev, pager, next"
                        :total="total">
                    </el-pagination>
                    
                </el-card>

                <el-dialog
                    title="修改信息"
                    :visible.sync="dialogVisible"
                    width="400px">
                        <el-row style="margin-bottom:10px">
                            <el-col :span="6">
                                <span >定额装载量</span>
                            </el-col>
                            <el-col :span="18">
                                <el-input style="width:100%" v-model="number" placeholder="定额装载量"></el-input>
                            </el-col>
                        </el-row>

                        <el-row style="margin-bottom:10px">
                            <el-col :span="6">
                                <span >装前重量</span>
                            </el-col>
                            <el-col :span="18">
                                <el-input style="width:100%" v-model="info1" placeholder="装前重量"></el-input>
                            </el-col>
                        </el-row>

                        <el-row style="margin-bottom:10px">
                            <el-col :span="6">
                                <span >装后重量</span>
                            </el-col>
                            <el-col :span="18">
                                <el-input style="width:100%" v-model="info2" placeholder="装后重量"></el-input>
                            </el-col>
                        </el-row>

                        <el-row style="margin-bottom:10px">
                            <el-col :span="6">
                                <span >当期装载量</span>
                            </el-col>
                            <el-col :span="18">
                                <el-input style="width:100%" v-model="now" placeholder="当期装载量"></el-input>
                            </el-col>
                        </el-row>

                        <el-row style="margin-bottom:10px">
                            <el-col :span="6">
                                <span >出发里程</span>
                            </el-col>
                            <el-col :span="18">
                                <el-input style="width:100%" v-model="info3" placeholder="出发里程"></el-input>
                            </el-col>
                        </el-row>

                        <el-row style="margin-bottom:10px">
                            <el-col :span="6">
                                <span >结束里程</span>
                            </el-col>
                            <el-col :span="18">
                                <el-input style="width:100%" v-model="info4" placeholder="结束里程"></el-input>
                            </el-col>
                        </el-row>

                        <el-row style="margin-bottom:10px">
                            <el-col :span="6">
                                <span >备注</span>
                            </el-col>
                            <el-col :span="18">
                                <el-input style="width:100%" v-model="beizhu" placeholder="备注"></el-input>
                            </el-col>
                        </el-row>

                        <el-row>
                            <el-col :span="6">
                                <span >业务时间</span>
                            </el-col>
                            <el-col :span="18">
                                <el-input style="width:100%" v-model="yw_time" placeholder="业务时间"></el-input>
                            </el-col>
                        </el-row>

                        <span slot="footer" class="dialog-footer">
                            <el-button @click="dialogVisible = false">取 消</el-button>
                            <el-button type="primary" @click="editSure()">确 定</el-button>
                        </span>
                </el-dialog>

    </div>
</template>

<script>
    import option from "../config/option.js"
    import { powerList,url2 } from '../router/api';
	export default{
		data(){
			return{
                total: 1,
                per_page: 50,
                current_page: 1,

                number:'',
                chepai_search:'',
                address:'',
                type:'',
                zhuangtai:'',
                siji:'',
                tableData: [],
               
                time: [],
                options: [],

                id:'',
                dialogVisible:false,
                number:'',
                info1:'',
                info2:'',
                now:'',
                info3:'',
                info4:'',
                beizhu:'',
                yw_time:'',

            }
        },
        async mounted() {
            var date = new Date();
            date.setTime(date.getTime());
            var Y = date.getFullYear() + '-';
            var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
            var D = (date.getDate() < 10 ? '0'+(date.getDate()) : date.getDate());
            var time1 = Y + M + '01'
            var time2 = Y + M +D
            this.time.push(time1)
            this.time.push(time2)

            await this.getUser()
            await this.getList()
        },
		methods: {
            async getUser() {
                await powerList({
                    id:'',
                    name:'',
                    tell: localStorage.getItem('ws_tell'),
                }).then(res => {
                    var list  = res.data[0].org.split(',')
                    list.map(item=> {
                        this.options.push(item)
                    })
                    this.address = this.options[0]
                    if(this.address == '全部') {
                        this.options = option.zhuchang
                    }
                }).catch(err => {
                    console.log(err);
                });
            },

            search() {
                this.current_page = 1
                this.getList()
            },
            handleCurrentChange(val) {
                this.current_page = val;
                this.getList();
            },
      
            caoZuo1(x,y) {
                this.$confirm('是否确定?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.axios.get(url2+'caoZuo1', {
                        params:{
                            id:x,
                            id_status:y,
                            shenpiren:localStorage.getItem('ws_name'),
                        }
                    }).then(res=> {
                        this.$message({
                            message: '操作成功',
                            type: 'success'
                        });
                        this.getList()
                    }).catch(err=> {
                        console.log(err);
                    });
                }).catch(() => {});
            },

            edit(x) {
                this.id = x.id,
                this.number = x.number,
                this.info1 = x.info1,
                this.info2 = x.info2,
                this.info3 = x.info3,
                this.info4 = x.info4,
                this.now = x.now,
                this.beizhu = x.beizhu,
                this.dialogVisible = true;
                this.yw_time = x.time;
            },

            editSure() {
                this.axios.get(url2+'edit', {
                    params:{
                        id:this.id,
                        number: this.number,
                        info1: this.info1,
                        info2: this.info2,
                        now: this.now,
                        info3: this.info3,
                        info4: this.info4,
                        beizhu:this.beizhu,
                        yw_time:this.yw_time
                    }
                }).then(res=> {
                    this.$message({
                        message: '操作成功',
                        type: 'success'
                    });
                    this.getList()
                    this.dialogVisible = false;
                }).catch(err=> {
                    console.log(err);
                });
            },
            
            daochu() {
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: '加载中',
                    background: 'rgba(0, 0, 0, 0.7)'
                });

                var time1 = ''
                var time2 = ''
                if(this.time) {
                    time1 = this.time[0] + ' 00:00:00'
                    time2 = this.time[1] + ' 23:59:59'
                }

                this.axios.get(url2+'searchList', {
                    params:{
                        export:1,
                        chepai:this.chepai_search,
                        zhuchang:this.address =='全部'? '':this.address,
                        type:this.type,
                        time1:time1,
                        time2:time2,
                        page:this.current_page,
                        per_page:this.per_page,
                        zhuangtai:this.zhuangtai,
                        siji:this.siji,
                    },
                    responseType: 'blob',
                }).then(res=> {
                    const data = res.data 
                    if (Object.prototype.toString.call(data) === '[object Blob]' && data.type.includes('application/vnd.ms-excel')) { 
                        const blob = res.data
                        const a = document.createElement('a')
                        let binaryData = [];
                        binaryData.push(blob);
                        const url= window.URL.createObjectURL(new Blob(binaryData));
                        a.href = url
                        a.download = '下载.csv'
                        a.click()
                        window.URL.revokeObjectURL(url)
                    }else{
                        this.$message.error('下载失败')
                    }
                    loading.close();
                }).catch(err=> {
                    console.log(err);
                    loading.close();
                });
            },


            async getList(n) {
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: '加载中',
                    background: 'rgba(0, 0, 0, 0.7)'
                });

                var time1 = ''
                var time2 = ''
                if(this.time) {
                    time1 = this.time[0] + ' 00:00:00'
                    time2 = this.time[1] + ' 23:59:59'
                }

                await this.axios.get(url2+'searchList', {
                    params:{
                        export:n?n:'',
                        chepai:this.chepai_search,
                        zhuchang:this.address =='全部'? '':this.address,
                        type:this.type,
                        time1:time1,
                        time2:time2,
                        page:this.current_page,
                        per_page:this.per_page,
                        zhuangtai:this.zhuangtai,
                        siji:this.siji,
                    }
                }).then(res=> {
                    this.tableData = res.data.data.data
                    this.total = res.data.data.total
                    loading.close();
                }).catch(err=> {
                    console.log(err);
                    loading.close();
                });
            },

        }
    }
</script>

<style scoped="scoped" lang='less'>
    .index {
        padding-left: 10px;
        span {
            font-size: 12px;
        }
    }
    .index .el-input {
        width:140px;
        margin-right: 20px;
    }

    .index .el-select {
        width:140px;
        margin-right: 20px;
    }
    .index main {
        margin-bottom: 20px;
    }
    .index .el-pagination {
        white-space: nowrap;
        
        padding: 2px 5px;
        color: #303133;
        float: right;
        font-weight: 700;
    }
</style>




